import React from 'react';

function ImageSection() {
    return (
        <div className="ImageSection">
            <div className="about-info">
                <h4>Curiosity is my source of inspiration.</h4>
                <p className="about-summary">
                    I like learning how systems work, finding patterns, and turning complex ideas into products people
                    can actually use. As co-founder and CTO of GM, I work on financial education tools that make markets,
                    investing, and personal finance feel more accessible. I am driven by the desire to keep exploring,
                    asking better questions, and building things that help others understand the world with more clarity.
                </p>
            </div>
        </div>
    )
}

export default ImageSection;
